export default {
  activeBuilding: {
    // backgroundColor: 'rgba(78, 163, 216, 0.1)',
    // borderRight: '7.5px solid #d9d9d9',
    fontWeight: 'bold',
    color: 'rgb(78, 163, 216)'
  },
  newBuilding: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0
  }
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMap/SidebarItemFacility/style.js